<script setup lang="ts">
import type { SiteWideMessagingPropertiesModel } from '~/types/contentapi';

const props = defineProps<SiteWideMessagingPropertiesModel>();

const { getNiceLink } = useLinkParser();
const niceLink = computed(() => {
  if (props.link) {
    return getNiceLink(props?.link[0]);
  }
  return null;
});
const { checkExternal } = usePathGuard();
</script>

<template>
  <div>
    <div class="container flex items-center justify-between p-4 align-middle max-md:flex-col md:space-x-8">
      <!--   Text -->
      <div class="flex flex-col items-center text-center md:max-w-[33%]">
        <div class="text-2xl uppercase" v-if="props.title">{{ props.title }}</div>
        <div v-if="props.text">{{ props.text }}</div>
      </div>
      <!-- center line divider -->
      <div class="flex-grow self-center border border-l-8 border-white max-md:hidden"></div>
      <!-- CTA -->
      <div class="flex justify-center max-md:w-full" v-if="niceLink">
        <Button
          variant="outline"
          as-child
          class="w-full bg-transparent text-center hover:bg-white hover:text-stormcloud"
        >
          <nuxt-link
            as="NuxtLink"
            :external="checkExternal(niceLink?.href)"
            :href="niceLink?.href"
            :target="niceLink?.target"
            class="flex justify-center"
          >
            {{ niceLink.title ?? niceLink.href }}
          </nuxt-link>
        </Button>
      </div>
    </div>
  </div>
</template>

<style scoped></style>
